export const SET_OPEN = 'notification:SET_OPEN';

export const GET_NOTIFICATIONS = 'notification:GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_SUCCESS = 'notification:GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_ERROR = 'notification:GET_NOTIFICATIONS_ERROR';

export const SET_NOTIFICATIONS_PILOT = 'notification:SET_NOTIFICATIONS_PILOT';

export const SET_CURRENT_NOTIFICATION = 'notification::SET_NOTIFICATIONS_PILOT';
export const RESET_CURRENT_NOTIFICATION = 'notification:RESET_CURRENT_NOTIFICATION';

export const GET_CURRENT_NOTIFICATION = 'notification::GET_CURRENT_NOTIFICATION';
export const GET_CURRENT_NOTIFICATION_SUCCESS = 'notification::GET_CURRENT_NOTIFICATION_SUCCESS';
export const GET_CURRENT_NOTIFICATION_ERROR = 'notification::GET_CURRENT_NOTIFICATION_ERROR';
